import { listCategories } from "../utils/firebase";
import type { ICategory } from "../entities/category.entity";
import { MINUTE } from "../utils/constants";

// Kiosks keep the same page open for months, so a cache without expiry means
// new/renamed folders never show up on the TV (and videos moved into a new
// subcategory lose their folder). Only listing metadata is cached here, never
// media files, so expiring it costs a few document reads.
const CATEGORIES_CACHE_TTL = 5 * MINUTE;

const cache = new Map<string, ICategory[]>();
let cacheTimestamp = 0;

export const lazyCategories = async (disableCache = false) => {
	const cacheEnabled = !disableCache;
	let categories: ICategory[] = [];

	const findSubCategoryById = (id: string) => {
		for (const category of categories || []) {
			for (const subCategory of category.subCategories || []) {
				if (subCategory.id === id) return subCategory;
			}
		}
	};

	const findCategoryById = (id: string) => {
		for (const category of categories || []) {
			if (category.id === id) return category;
		}
	};

	if (cacheEnabled) {
		const cachedCategories = cache.get("categories");
		if (
			cachedCategories &&
			Date.now() - cacheTimestamp < CATEGORIES_CACHE_TTL
		) {
			categories = cachedCategories;
		}
	}

	if (!categories.length) {
		const categoriesResult = await listCategories();
		if (categoriesResult) {
			cache.set("categories", categoriesResult);
			cacheTimestamp = Date.now();
		}
		categories = categoriesResult;
	}

	return {
		categories,
		findSubCategoryById,
		findCategoryById,
	};
};
